var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecipes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 127 127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#d6ecf0",
    cx: 63.5,
    cy: 63.61,
    r: 63.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#32a1b3",
    d: "M97.88,45.69c-1.47-3.41-3.79-6.28-6.71-8.29-2.92-2.02-6.29-3.08-9.74-3.07h-.04s-.06.01-.09.02c-1.4-2.65-3.23-4.91-5.45-6.73-2.19-1.8-4.66-3.08-7.33-3.82-5.16-1.42-10.54-.63-15.17,2.24-3.19,1.98-5.83,4.85-7.66,8.31-.03,0-.06-.01-.09-.02h-.04s-.03,0-.04,0c-4.83,0-9.38,2.05-12.81,5.78-3.43,3.74-5.32,8.71-5.34,14,0,3.77.96,7.44,2.8,10.63,1.82,3.14,4.39,5.66,7.45,7.27v27.06c0,1.68,1.26,3.05,2.81,3.05h46.13c.75,0,1.46-.32,1.99-.9.53-.57.81-1.34.82-2.15v-27.06c4.31-2.28,7.58-6.24,9.19-11.18,1.63-4.98,1.39-10.36-.68-15.15ZM83.75,90.9v5.12h-40.52v-5.12h40.52ZM79.08,71.52c.26-1.65-.77-3.23-2.29-3.51-.7-.13-1.41.03-2.01.45-.65.46-1.1,1.21-1.24,2.04l-2.18,14.3h-5.07v-13.78c0-1.68-1.26-3.05-2.81-3.05s-2.81,1.37-2.81,3.05v13.78h-5.07l-2.17-14.28c-.13-.84-.58-1.58-1.24-2.04-.59-.42-1.31-.58-2.01-.45-1.51.28-2.54,1.85-2.29,3.49l2.02,13.28h-6.7v-14.81c0-1.28-.75-2.44-1.86-2.87-6.52-2.49-9.97-10.32-7.69-17.46,1.5-4.72,5.18-8.13,9.66-8.98-.37,1.67-.57,3.38-.59,5.1,0,1.68,1.26,3.05,2.81,3.05s2.81-1.37,2.81-3.05c0-9.14,6.79-16.58,15.13-16.58s15.13,7.44,15.13,16.58c0,1.68,1.26,3.05,2.81,3.05s2.81-1.37,2.81-3.05c-.02-1.72-.22-3.43-.59-5.09,6.63,1.26,11.2,8.11,10.23,15.46-.67,5.08-3.84,9.29-8.26,10.98h0c-1.11.43-1.86,1.58-1.86,2.87v14.81h-6.7l2.02-13.28Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipes);
export default __webpack_public_path__ + "static/media/recipes.023a8c9e0cf078f26b4807aaa1e33b82.svg";
export { ForwardRef as ReactComponent };